// extracted by mini-css-extract-plugin
export default {"header-container":"styles_header-container__Z51vl","logo":"styles_logo__CDkiL","buttonWidth":"styles_buttonWidth__O0BAt"};